import React from 'react';

import {
  DeleteButton,
  SaveButton,
  Toolbar,
  useNotify,
  useRecordContext,
  useRedirect,
  useResourceContext,
} from 'react-admin';

import { PluginResource } from '@src/types';
import { PluginConfigVersion } from '@troverecommerce/ps-configs-api-client';

const PluginEditToolbar = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const resource = useResourceContext() as PluginResource;
  const record = useRecordContext<{ configVersion: PluginConfigVersion }>();

  if (!record) return;

  const { configVersion } = record;

  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <SaveButton />
      <DeleteButton
        confirmContent="Are you sure you want to delete this configuration? This action cannot be undone."
        confirmTitle="Delete Configuration"
        disabled={configVersion?.isDefault}
        mutationMode="pessimistic"
        mutationOptions={{
          onSuccess: () => {
            notify('Configuration file deleted successfully', { type: 'success' });
            redirect(`/${resource}`);
          },
          onError: (error) => {
            if (error instanceof Error) {
              notify(`Error deleting configuration file: ${error.message}`, { type: 'error' });
            } else {
              notify('Error deleting configuration file', { type: 'error' });
            }
          },
        }}
      />
    </Toolbar>
  );
};

export default PluginEditToolbar;